import React, { Component } from 'react';
import {
    Descriptions, List, Skeleton,
    Avatar, Button, Checkbox, message
} from 'antd';
import './list.css'
import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { RootState } from '../../../../core/reducers';
import { Link, RouteComponentProps } from 'react-router-dom';
import { withTranslation, WithTranslationProps } from 'react-i18next'
import icon_scan from "./images/icon_scan.png"
import moment from 'moment';
import { actionExportData } from '../../../../core/actions/silizhu/report';
import { actionGetExamineeDetail } from '../../../../core/actions/silizhu/examinee';
import { ExportExaminationReportRequest } from '../../../../api/sennotech/scanner/v2/examination';
import { Language } from '../../../../api/sennotech/scanner/v2/type';

interface StateProps {
    orgId: any
    examineeDetail: any
    routeKey: string
}

interface DispatchProps {
    getExamineeDetail(data): void
    exportData(data: ExportExaminationReportRequest): void
}

interface RouteState {
    id: string
}

type TypeProps = StateProps & RouteComponentProps<RouteState>;

const CheckboxGroup = Checkbox.Group;

class Index extends Component<TypeProps & DispatchProps & WithTranslationProps> {

    constructor(props) {
        super(props)
    }

    state = {
        pageNum: 1,
        pageSize: 10,
        checkedList: [],
        plainOptions: [],
        checkAll: true,
    }

    list = []; num = -1;
    componentDidMount() {
        let examineeId = this.props.match.params.id;
        this.list = [];
        this.num = -1;
        this.props.getExamineeDetail({
            examineeId,
            pageNum: 1,
            pageSize: 10
        })
        const i18n = this.props.i18n;
        if (!i18n) {
            return;
        }
        this.setState({
            checkedList: [
                i18n.t('standingReportTitle'),
                i18n.t('dynamicReportTitle'),
                i18n.t('scanReportTitle'),
            ],
            plainOptions: [
                i18n.t('standingReportTitle'),
                i18n.t('dynamicReportTitle'),
                i18n.t('scanReportTitle'),
            ]
        })
    }

    onLoadMore = (num) => {
        let examineeId = this.props.match.params.id;
        this.props.getExamineeDetail({
            examineeId,
            pageNum: num + 1,
            pageSize: 10
        })
    }

    returnReportUrl = (record) => {
        // let routeKey = this.props.routeKey;
        // let id = record.ticket;
        // return `/${routeKey}/examineeList/detail/silizhuReport/${id}`;
        let editableUrl = record.editableUrl;
        return editableUrl + "&exportable=true";
    }


    onCheckAllChange = (e) => {
        let plainOptions = this.state.plainOptions;
        this.setState({
            checkedList: e.target.checked ? plainOptions : [],
            checkAll: e.target.checked
        })
    }

    onChange = (list) => {
        let plainOptions = this.state.plainOptions;
        this.setState({
            checkedList: list,
            checkAll: list.length === plainOptions.length
        })
    }

    exportData = () => {
        const checkedList = this.state.checkedList;
        const i18n = this.props.i18n;
        if (checkedList.length === 0) {
            message.error(i18n?.t("selectNotNull"), 6);
            return;
        }
        else {
            let examineeId = this.props.match.params.id;
            const orgId = this.props.orgId;
            this.props.exportData({
                storeId: +orgId,
                examineeId: +examineeId,
                language: i18n?.language === "en" ? Language.EN : Language.ZH,
            })
        }
    }
    render() {

        const i18n = this.props.i18n;

        if (!i18n) {
            return <p></p>
        }

        const data = this.props.examineeDetail || {};
        const examinee = data.examinee || {};

        let contactWay = '';
        if (examinee.mobileNumber) {
            contactWay = examinee.mobileNumber;
        }
        else if (examinee.email) {
            contactWay = examinee.email;
        }

        const loadMore =
            data.reports && data.totalPages !== 0 &&
            data.totalPages !== data.pageNum + 1 ? (
                <div
                    style={{
                        textAlign: 'center',
                        marginTop: 12,
                        height: 32,
                        lineHeight: '32px',
                    }}
                >
                    <Button onClick={() => this.onLoadMore(data.pageNum + 1)}>{i18n?.t('more')}</Button>
                </div>
            ) : null;

        if (data.reports && data.pageNum > this.num) {
            this.num = data.pageNum;
            this.list.push.apply(this.list, data.reports)
        }


        let gender = "";
        if (examinee.gender === "MALE") {
            gender = i18n?.t('male')
        }
        else if(examinee.gender === 'FEMALE') {
            gender = i18n?.t('female')
        }

        let age = "";
        if(examinee.birthTime) {
            let birthDayTime = new Date(examinee.birthTime).getTime();
            if(birthDayTime) {
                let nowTime = new Date().getTime();
                age = Math.floor((nowTime - birthDayTime) / 31536000000).toString();
            }
        }

        console.log(this.list)

        return (
            <div className="userdetail">
                <div className="model">
                    <Descriptions title={examinee.nickname} size="small">
                        <Descriptions.Item label={i18n?.t('gender')}>{gender}</Descriptions.Item>
                        <Descriptions.Item label={i18n?.t('age')}>{age}岁</Descriptions.Item>
                        <Descriptions.Item label={i18n?.t('height')}>{examinee.height}cm</Descriptions.Item>
                        <Descriptions.Item label={i18n?.t('weight')}>{examinee.weight}kg</Descriptions.Item>
                        <Descriptions.Item label={i18n?.t('contactWay')}>{contactWay}</Descriptions.Item>
                        <Descriptions.Item label={i18n?.t('remark')}>{examinee.description}</Descriptions.Item>
                    </Descriptions>
                </div>
                <div className="model">
                    {/* {
                        data.totalPages !== 0 &&
                        <div className='margin-topBot-20'>
                            <Button
                                type="primary"
                                className="margin-left-20"
                                onClick={this.exportData}
                            >{i18n?.t('exportData')}</Button>
                        </div>
                    } */}
                    <List
                        size='large'
                        loading={!this.list.length && !data.pageSize}
                        itemLayout="horizontal"
                        loadMore={loadMore}
                        dataSource={this.list || []}
                        renderItem={
                            (item: any) => (
                                <List.Item
                                    actions={
                                        [
                                            item.state === "SUCCESS" &&
                                            // <Link to={{ pathname: this.returnReportUrl(item), state: 'back', search: '?isSave=true' }}>
                                            //     {i18n?.t('view')}
                                            // </Link>
                                            <a href={this.returnReportUrl(item)} target="_blank">
                                                {i18n?.t('view')}
                                            </a>
                                        ]
                                    }>
                                    <Skeleton
                                        avatar title={false} loading={!item.ticket} active>
                                        <List.Item.Meta
                                            avatar={
                                                <Avatar
                                                    size="large"
                                                    src={icon_scan}
                                                />
                                            }
                                            title={
                                                item.state === "SUCCESS" ? 
                                                // <Link to={{ pathname: this.returnReportUrl(item), state: 'back', search: '?isSave=true' }}>
                                                //     {i18n?.t('silizhuReportTitle')}
                                                // </Link> 
                                                <a href={this.returnReportUrl(item)} target="_blank">
                                                    {i18n?.t('silizhuReportTitle')}
                                                </a> 
                                                : i18n?.t('silizhuReportTitle')
                                            }
                                            description={`${i18n?.t('detectionTime')}:${moment((new Date(item.createTime).getTime())).format('YYYY-MM-DD HH:mm:ss')}`}
                                        />
                                        {item.state === "FAIL" && <div className='error'>数据无效</div>}
                                    </Skeleton>
                                </List.Item>
                            )}
                    />
                </div>
            </div>
        )
    }
}

function mapStateToProps(state: RootState): StateProps {
    return {
        orgId: state.user.orgId,
        examineeDetail: state.silizhuExaminee.examineeDetail,
        routeKey: state.user.routeKey,
    }
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
    return {
        getExamineeDetail: (data) => {
            dispatch(actionGetExamineeDetail(data))
        },
        exportData: (data) => {
            dispatch(actionExportData(data))
        }
    }
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Index))